import React from "react";
import Row from "../layout/Row";

function InfoCell({ title, data, editable = false }) {
  return (
    <div className="flex flex-row items-center gap-1 h-fit">
      {title && (
        <div className="text-h3 font-medium min-w-c100 w-c100 h-fit">
          {title}
        </div>
      )}
      <div
        className={`text-h3 rounded-md py-1 break-all h-fit min-h-7 w-c200 px-2 mr-2  flex-grow bg-shadow_4  font-light text-pr ${editable ? "cursor-pointer border-slate-200 hover:border-blue-400 border-2" : " "}`}
      >
        {data}
      </div>
    </div>
  );
}

export default InfoCell;
